import { MessageTypesVerbose } from "../../../types/Chat";

// fi fi-rr-file-csv
export const mapMessageFiles = {
    pdf: {
        icon: "fi fi-rr-file-pdf",
        type: MessageTypesVerbose.DOCUMENT_MESSAGE,
    },
    txt: {
        icon: "fi fi-rr-document",
        type: MessageTypesVerbose.DOCUMENT_MESSAGE
    },
    doc: {
        icon: "fi fi-rr-file-word",
        type: MessageTypesVerbose.DOCUMENT_MESSAGE
    },
    docx: {
        icon: "fi fi-rr-file-word",
        type: MessageTypesVerbose.DOCUMENT_MESSAGE
    },
    jpg: {
        icon: '',
        type: MessageTypesVerbose.IMAGE_MESSAGE
    },
    jpeg: {
        icon: '',
        type: MessageTypesVerbose.IMAGE_MESSAGE
    },
    png: {
        icon: '',
        type: MessageTypesVerbose.IMAGE_MESSAGE
    },
    gif: {
        icon: '',
        type: MessageTypesVerbose.IMAGE_MESSAGE
    },
};

export const mapSystemMessageIcons = {
    [MessageTypesVerbose.GROUP_CREATED]: 'fi fi-rr-users-medical',
    [MessageTypesVerbose.PARTICIPANTS_ADDED]:  'fi fi-rr-user-add',
    [MessageTypesVerbose.PARTICIPANT_REMOVED]:  'fi fi-rr-remove-user',
    [MessageTypesVerbose.PARTICIPANT_LEFT_GROUP]:  'fi fi-rr-remove-user'
}

export const mapMessageApiField = {
    [MessageTypesVerbose.MESSAGE]: 'message',
    [MessageTypesVerbose.DOCUMENT_MESSAGE]: 'document',
    [MessageTypesVerbose.IMAGE_MESSAGE]: 'image',
};

export const chatDocumentTypes = ["TXT", "DOC", "DOCX", "PDF", "CSV", "XLSX", "XLS"];
export const chatImageTypes = ["JPG", "JPEG", "PNG", "GIF"];
export const chatFileTypes = [...chatDocumentTypes, ...chatImageTypes];

export const allowedMessageTypes = [
    MessageTypesVerbose.IMAGE_MESSAGE,
    MessageTypesVerbose.DOCUMENT_MESSAGE,
    MessageTypesVerbose.MESSAGE
    // MessageTypesVerbose.GROUP_CREATED,
    // MessageTypesVerbose.PARTICIPANTS_ADDED,
    // MessageTypesVerbose.PARTICIPANT_REMOVED,
    // MessageTypesVerbose.PARTICIPANT_LEFT_GROUP
];

export const systemMessageTypes = [
    MessageTypesVerbose.GROUP_CREATED,
    MessageTypesVerbose.PARTICIPANTS_ADDED,
    MessageTypesVerbose.PARTICIPANT_REMOVED,
    MessageTypesVerbose.PARTICIPANT_LEFT_GROUP
];

export const awayTimeout = 3 * 60 * 1000;
export const loadThreadsInterval = 5 * 60 * 1000;
export const refreshTokenInterval = 12 * 60 * 1000;
